const state = {
  message: null,
  role: null
};

const mutations = {
  setMessage(state, payload) {
    state.message = payload.message;
    state.role = payload.role;
  },
  clearMessage(state) {
    state.message = null;
    state.role = null;
  }
};

const actions = {};

const getters = {
  message(state) {
    return state.message;
  },
  role(state) {
    return state.role;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
